/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'icon-link.scss' instead.
import { css } from 'lit';
export default css `:host{margin-left:var(--cipublic-size-xxs);margin-top:calc(-.25em + 1px)}:host([name=chevron-action]){--icon-width:calc(var(--cipublic-size-m) + var(--cipublic-size-xs))}`;
//# sourceMappingURL=icon-link.scss.js.map